import { FilterOperatorType } from './filter-operator-type';
import { FilterUIType, ODataFilter, ODataFilterValues } from './odata-filter';
import { FilterOperator } from './operators';
import { SearchValueType } from './search-value-type';

export class SelectedFilter {
  filter: ODataFilter;
  filterOperator: FilterOperator;
  selectedSubFilters: SelectedFilter[] = [];
  searchValue?: any = null;
  searchValues?: ODataFilterValues[] = [];
  isFilterApplied = false;
  showFieldDeletedWarning = false;
  constructor(data: any) {
    if (!data) return;
    this.filter = data.filter;
    this.filterOperator = data.filterOperator;
    this.selectedSubFilters = data.selectedSubFilters ?? [];
    this.searchValue = data.searchValue ?? null;
    this.searchValues = data.searchValues ?? [];
    this.showFieldDeletedWarning = data.showFieldDeletedWarning ?? false;
  }

  get isValid(): boolean {
    return (
      this.filter &&
      this.filterOperator &&
      ((this.filterOperator.isSearchValueNeeded &&
        (this.searchValues.length > 0 ||
          (this.searchValue != null && this.searchValue.toString() != ''))) ||
        !this.filterOperator.isSearchValueNeeded)
    );
  }

  get uiType(): FilterUIType {
    if (!this.filter) return null;
    const valueType = this.filterOperator?.behaveAs ?? this.filter.valueType;
    if (valueType == SearchValueType.List || valueType == SearchValueType.Boolean)
      return FilterUIType.DropDown;
    if (
      valueType == SearchValueType.MultiValue ||
      valueType == SearchValueType.EvaluationAggregateMultiValue ||
      valueType == SearchValueType.WorkspaceMultiValue ||
      valueType == SearchValueType.EmptyOperator
    )
      return FilterUIType.Multiselect;
    if (
      valueType == SearchValueType.Skill &&
      this.filterOperator.actualOperator != FilterOperatorType.contains
    )
      return FilterUIType.Multiselect;
    if (
      valueType == SearchValueType.Skill &&
      this.filterOperator.actualOperator === FilterOperatorType.contains
    )
      return FilterUIType.Textbox;
    if (valueType == SearchValueType.Date || valueType == SearchValueType.DateRange)
      return FilterUIType.DatePicker;
    if (
      valueType == SearchValueType.String ||
      valueType == SearchValueType.Email ||
      valueType == SearchValueType.Number ||
      valueType == SearchValueType.EvaluationAggregateString
    )
      return FilterUIType.Textbox;
  }

  get hasSubFilter(): boolean {
    return this.filter && this.filter.subFilter?.filters.length > 0;
  }

  get isSubFilterAdded(): boolean {
    return this.selectedSubFilters.length > 0;
  }

  get isSubFilterValid(): boolean {
    return this.selectedSubFilters.findIndex((x) => !x.isValid) == -1;
  }

  get isSubFilerApplied(): boolean {
    return this.selectedSubFilters.findIndex((x) => !x.isFilterApplied) == -1;
  }

  get appliedSubFilters(): SelectedFilter[] {
    return this.selectedSubFilters.filter((x) => x.isValid).map((x) => new SelectedFilter(x));
  }

  getSubQueryFilters(buildForAutomation: boolean): any {
    return this.appliedSubFilters.map((x) =>
      x.filter.buildFilter(
        x.searchValues.length > 0 ? x.searchValues : x.searchValue,
        x.filterOperator,
        [],
        buildForAutomation
      )
    );
  }
}
